import React from "react";
import Cx from "classnames";

import * as styles from "./ExportSpreadsheet.module.scss";

export default function FieldList({
  fieldSchema,
  selectedFields,
  onSelectField,
  onSelectAll,
  onSelectNone,
}) {
  return (
    <ul className={styles.fieldOptionList}>
      {fieldSchema.map((field, i) => (
        <React.Fragment key={field.name}>
          <li
            className={Cx(
              {
                [styles.lineBreak]: field.lineBreak,
                [styles.columnBreak]: field.columnBreak,
              },
              styles.fieldOption
            )}
          >
            <input
              type="checkbox"
              value={field.name}
              onChange={onSelectField}
              data-field-name={field.name}
              checked={selectedFields.includes(field.name)}
            />
            <label onClick={onSelectField} data-field-name={field.name}>
              {field.label}
            </label>
          </li>
          {i === fieldSchema.length - 1 && (
            <>
              <button
                className={styles.unstyledButton}
                style={{ marginTop: "20px" }}
                onClick={onSelectAll}
              >
                Select all
              </button>
              <button
                className={styles.unstyledButton}
                style={{ marginTop: "6px" }}
                onClick={onSelectNone}
              >
                Select none
              </button>
            </>
          )}
        </React.Fragment>
      ))}
    </ul>
  );
}
